module.exports = __webpack_public_path__ + "img/meeting.960c7c26.jpg";